import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Organization } from '../models/organization';

@Injectable({
  providedIn: 'root'
})
export class OrganizationAdminService {

  private REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  constructor(private http:HttpClient) { }

  public getOrganizations(filterParams:any = {}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/organisations`,{params:filterParams,observe:'response'});
  }

  public createOrganization(orgData:Organization){
    return this.http.post(`${this.REST_API_SERVER}/organisations/create`,orgData);
  }

  

}
